import { render, staticRenderFns } from "./RankingQDIIOffShore.vue?vue&type=template&id=58690c88&scoped=true&"
import script from "./RankingQDIIOffShore.vue?vue&type=script&lang=js&"
export * from "./RankingQDIIOffShore.vue?vue&type=script&lang=js&"
import style0 from "./RankingQDIIOffShore.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingQDIIOffShore.vue?vue&type=style&index=1&id=58690c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58690c88",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingQDIIOffShore.vue"
export default component.exports